import type {CSSProperties} from 'react';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeBriefTakeLook = 'brieftake-refresh' | 'brieftake-copy' | 'brieftake-copy-err';

export const isWedgeBriefTakeLook = (look: string | undefined): look is WedgeBriefTakeLook => look !== undefined && look.startsWith('brieftake-');

/* The two small controls of the take section of a brief (Wedge). Refresh is the 28px outline chip of the outcome hint that follows a lost or
   pushed call: 11px at 600 weight on the elevated fill with the 1px card border and a 6px radius. Copy is the bare 28px text control that sits
   at the top right of the take: 12.5px at 600 weight with a 5px gap between its glyph and its label, in the accent ink, and in the amber ink
   once the clipboard write failed (copy-err). Both keep the declaration order of the source and the legacy variable names, sit on the tap
   highlight reset and manipulation touch action, and draw no transparent target and no anchor (`wedgeSettingsDrawsHit`, and a `content: none`
   rule naming the prefix): the legacy controls drew none and sit in compact rows. The caller owns the labels, the glyph and the handlers. */
const TAP = {WebkitTapHighlightColor: 'transparent', touchAction: 'manipulation'} as const;

export function wedgeBriefTakeStyle(look: WedgeBriefTakeLook): CSSProperties {
  const r = wedgeExactRole;
  if (look === 'brieftake-refresh') return {
    padding: '4px 10px', background: r('bgElev'), border: `1px solid ${r('cardBorder')}`, borderRadius: 6, color: r('label'),
    fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: r('font'), minHeight: 28, ...TAP,
  };
  return {
    display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12.5, fontWeight: 600,
    color: look === 'brieftake-copy-err' ? r('amber') : r('accent'),
    background: 'none', border: 0, cursor: 'pointer', fontFamily: r('font'), padding: 4, minHeight: 28, ...TAP,
  };
}
